module.exports = __webpack_public_path__ + "static/media/material-glossy.3a168776.svg";